import { Modal } from '@cma/common'
import { PdfPreview } from '@cma/common/PdfPreview'
import { PlatformClientContentPartsFragment } from '@cma/generated/graphql'
import { isImageContent, isPdfContent } from './utils'

interface ContentPreviewModalProps {
  content: PlatformClientContentPartsFragment | null
  onClose: () => void
}

export function ContentPreviewModal({
  content,
  onClose
}: ContentPreviewModalProps) {
  if (content && isPdfContent(content)) {
    return (
      <PdfPreview
        url={content.platformClientContentUrl || ''}
        showPreview
        onClose={onClose}
      />
    )
  }

  return (
    <Modal size="4xl" fullHeight isOpen={!!content} onClose={onClose}>
      <Modal.Title>Preview</Modal.Title>
      <div className="-mx-6 -mb-6 mt-4 flex h-full items-center justify-center bg-gray-600 p-6">
        {content && isImageContent(content) ? (
          <img
            src={content.platformClientContentUrl || ''}
            alt={content.displayName || 'Preview'}
            className="max-h-full max-w-full object-contain"
          />
        ) : (
          <p className="helix-body text-white">
            Preview isn&apos;t available for this file type.
          </p>
        )}
      </div>
    </Modal>
  )
}
